import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  GlobalStyles
} from '@mui/material';
import { ArrowRight, CheckCircle } from '@mui/icons-material';
import { motion } from 'framer-motion';
import getStyles from './styles';
import { useNavigate } from 'react-router-dom';

const globalStyles = (
  <GlobalStyles
    styles={{
      '@keyframes glow': {
        '0%': {
          opacity: 0.6,
          boxShadow: '0 0 20px rgba(79, 70, 229, 0.3)'
        },
        '100%': {
          opacity: 1,
          boxShadow: '0 0 30px rgba(79, 70, 229, 0.6)'
        }
      },
      '@keyframes fadeIn': {
        '0%': {
          opacity: 0,
          transform: 'translateY(30px)'
        },
        '100%': {
          opacity: 1,
          transform: 'translateY(0)'
        }
      },
      '@keyframes fadeInScale': {
        '0%': {
          opacity: 0,
          transform: 'scale(0.8)'
        },
        '100%': {
          opacity: 1,
          transform: 'scale(1)'
        }
      }
    }}
  />
);

const MVPBanner = () => {
  const [scrollY, setScrollY] = useState(0);
  const styles = getStyles();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleStartProject = () => {
    navigate('/contact');
  };

  // const handleViewPricing = () => {
  //   console.log('View Pricing');
  // };

  const TimelineStep = ({ day, label, delay = false }) => (
    <Box
      sx={{
        ...styles.timelineStep,
        animation: `fadeInScale 0.6s ease-out ${delay ? '0.2s' : '0s'} both`
      }}
    >
      <Box sx={styles.stepIconContainer}>
        <CheckCircle sx={styles.stepIcon} />
      </Box>
      <Box sx={styles.stepContent}>
        <Typography variant="body1" sx={styles.stepDay}>
          {day}
        </Typography>
        <Typography variant="body2" sx={styles.stepLabel}>
          {label}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Box component="section" sx={styles.heroSection}>
      {globalStyles}

      {/* Parallax Background */}
      <Box
        sx={styles.parallaxBackground}
        style={{
          transform: `translateY(${scrollY * 0.5}px)`
        }}
      />

      {/* Animated gradient overlay */}
      <Box sx={styles.gradientOverlay} />

      <Container maxWidth="lg" sx={styles.container}>
        <Box sx={styles.content}>
          <Typography variant="h1" sx={styles.mainHeadline}>
            <Typography component="span" sx={styles.headlineLine1}>
              Get Your Website
            </Typography>
            <Typography component="span" sx={styles.headlineLine2}>
              <span style={styles.textGradient}>LIVE</span> in Just{' '}
              <span style={styles.textGlow}>2 Days</span>
            </Typography>
            <Typography component="span" sx={styles.subtitleLine}>
              Or Your Money Back!
            </Typography>
          </Typography>

          {/* Subtitle */}
          <Typography sx={styles.subtitle}>
            <span style={styles.subtitleHighlight}>Amizhth Express:</span> Fast,
            Professional Websites Ready in Just 48 Hours.{' '}
            <span style={styles.accentText}>No Compromises, No Delays.</span>
          </Typography>

          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <Box sx={styles.ctaContainer}>
              <Button
                sx={styles.primaryButton}
                onClick={() => handleStartProject()}
              >
                Start Your Digital Journey
                <motion.span
                  sx={styles.buttonIcon}
                  animate={{ x: 0 }}
                  whileHover={{ x: 5 }}
                >
                  <ArrowRight />
                </motion.span>
              </Button>
              {/* <Button sx={styles.outlineButton} onClick={handleViewPricing}>
                View Pricing
              </Button> */}
            </Box>
          </motion.div>

          {/* Timeline Visualization */}
          <Box sx={styles.timelineContainer}>
            <Paper sx={styles.timelineCard}>
              <Typography variant="h3" sx={styles.timelineTitle}>
                Your Website Journey
              </Typography>
              <Box sx={styles.timelineContent}>
                <TimelineStep
                  day="Day 1"
                  label="Kickoff & Content Submission"
                />
                <Box sx={styles.timelineConnector} />
                <TimelineStep day="Day 2" label="Website LIVE Launch" delay />
              </Box>
            </Paper>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default MVPBanner;
